import { useDraggable } from '@dnd-kit/core';

const DraggablePickupCard = ({ pickup, children }) => {
  // DRAG
  const {
    attributes,
    listeners,
    setNodeRef: setDraggableNodeRef,
    isDragging,
  } = useDraggable({
    id: `pickup-${pickup.id}`,
    data: {
      pickup,
    },
  });

  // DROP
  const setRefs = (node) => {
    setDraggableNodeRef(node);
  };

  const style = {
    cursor: 'grab',
    opacity: isDragging ? 0 : 1,
    touchAction: 'none',
  };

  return (
    <div ref={setRefs} style={style} {...listeners} {...attributes}>
      {children}
    </div>
  );
};

export default DraggablePickupCard;
